import { Text } from '../../text/text.component';
import * as styles from '../index-row.styles';

export const HelperText = ({ helperText }: { helperText: React.ReactNode }) => {
  return (
    <section className={styles.helperTextContainerStyle}>
      {typeof helperText === 'string' ? (
        <Text size='small' color='light' className={styles.noMarginStyle}>
          {helperText}
        </Text>
      ) : (
        helperText
      )}
    </section>
  );
};
